import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translate';
import './Header.css';

const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => {
    return currentPath === path ? 'open' : '';
  };

  // 如果是首页，不显示导航链接；其他页面显示
  const isHomePage = currentPath === '/';

  return (
    <header className="header">
      <div className="menu-box">
        <div className="menu">
          <div className="logo">
            <Link to="/">
              <img 
                src="/images/logo.jpg" 
                alt="DayDayGo" 
                className="logo-img"
              />
            </Link>
          </div>
          <div className="nav-container">
            {/* 非首页显示导航链接 */}
            {!isHomePage && (
              <nav className="nav">
                <Link to="/" className={`nav-link ${isActive('/')}`}>{t('nav.home', language)}</Link>
                <Link to="/about" className={`nav-link ${isActive('/about')}`}>{t('nav.about', language)}</Link>
                <Link to="/guide" className={`nav-link ${isActive('/guide')}`}>{t('nav.guide', language)}</Link>
                <Link to="/shop" className={`nav-link ${isActive('/shop')}`}>{t('nav.shop', language)}</Link>
              </nav>
            )}
            <div className="language-switcher">
              <button 
                className={`lang-btn ${language === 'ja' ? 'active' : ''}`}
                onClick={() => toggleLanguage('ja')}
              >
                {t('header.japanese', language)}
              </button>
              <span className="lang-separator">|</span>
              <button 
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                onClick={() => toggleLanguage('en')}
              >
                {t('header.english', language)}
              </button>
              <span className="lang-separator">|</span>
              <button 
                className={`lang-btn ${language === 'zh_tw' ? 'active' : ''}`}
                onClick={() => toggleLanguage('zh_tw')}
              >
                {t('header.traditionalChinese', language)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
